var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDoNotEnter = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  enableBackground: "new 0 0 510 510",
  height: 512,
  viewBox: "0 0 510 510",
  width: 512,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_59_",
  d: "m255 510c-140.93 0-255-114.049-255-255 0-140.929 114.049-255 255-255l10 255z",
  fill: "#464e53"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_78_",
  d: "m255 0v510c140.932 0 255-114.05 255-255 0-140.931-114.049-255-255-255z",
  fill: "#30373d"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_57_",
  d: "m255 30c-124.065 0-225 100.935-225 225s100.935 225 225 225l10-225z",
  fill: "#ffda45"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_74_",
  d: "m255 30v450c124.065 0 225-100.935 225-225s-100.935-225-225-225z",
  fill: "#ffaa45"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_178_",
  d: "m165 285h90l45-30-45-30h-90z",
  fill: "#464e53"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_69_",
  d: "m255 225h90v60h-90z",
  fill: "#30373d"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDoNotEnter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/do-not-enter.f2354b84.svg";
export { ForwardRef as ReactComponent };